import { render, staticRenderFns } from "./TaskPipelinesConfiguration.vue?vue&type=template&id=2cb61606&"
import script from "./TaskPipelinesConfiguration.vue?vue&type=script&lang=ts&"
export * from "./TaskPipelinesConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports